import {styled} from "@mui/material/styles";
import { TableCell, TableContainer, Chip } from "@mui/material";
import { useColors } from "../../../../Context/ColorsContext"
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { desktop } = MediaQuerys;

export const CustomTableCell = styled(TableCell)(() => {
  const { colors } = useColors();
  return {
    color:colors.detailTextColor,
    fontSize:'1rem',
    fontWeight:600,
    paddingTop:'10px !important',
    paddingBottom:'10px !important',
    alignItems:'center',
    [desktop]: {
      fontSize:'0.75rem !important',
    }
  }
})

export const CustomChipStatus = styled(Chip)(({ enabled }) => {
  return {
    backgroundColor: enabled ? "#c7f6d6" : "#ffe4e5",
    color: enabled ? "#147342" : "#ef4444",
    fontWeight: 600,
    fontSize: '11px',
    height: '22px',
    borderRadius: '16px',
    padding: '0 2px',
    "& .MuiChip-label": {
      padding: "0 8px",
    },
    "& .MuiChip-icon": {
      color: "inherit",
      marginLeft: "6px",
      marginRight: "-4px",
      fontSize: "14px",
    }
  }
});

export const TableCellStatus = styled(TableCell)(() => ({
    display:'flex',
    alignItems: 'center'

}))
export const ContainerCell = styled('div')(() => ({
    display:'flex',
    alignItems:'center',
}))

export const Figure = styled('figure')(({code}) => ({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  background: code,
  height:'30px',
  width:'30px',
  minWidth:'30px',
  borderRadius:'50%',
  marginRight:'10px !important',
}))

export const SectionInfo = styled('section')(() => ({
    display:'flex',
    flexDirection:'column'
}))

export const InfoCell = styled('div')(() => ({
}))

export const Label = styled('label')(() => ({
  fontSize:'14px',
  paddingRight:'5px'
}))

export const InputDate = styled('input')(({theme}) => {
  const { colors } = useColors();
  return {
    marginRight:'20px',
    borderBottom:'1px solid '+colors.grayFont,
    borderRadius:'3px',
    fontFamily: theme.typography.fontFamily,
    padding:'5px 10px',
    width:'150px',
  }
})

export const FigureHead = styled('figure')(() => ({
  display:'flex'
}))

export const GroupAction = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.90rem',
  }
})

export const ContainerGroup = styled('div')(() => {
  return {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexDirection: 'row',
      gap: '0.75rem'
  }
})

export const IconArea = styled('div')(() => {
  const { colors } = useColors();
  return {
      width: 15,
      height: 15,
      fontSize: 10,
      fontWeight: 'bold',
      color: colors.white,
      background: colors.buttonActionColor,
      borderRadius: 20,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 'auto',
      [desktop]: {
          height: 15,
          width: 15
      }
  }
})

export const CustomTyphography = styled('span')(() => {
  return {
      [desktop]: {
          // fontSize: '0.65rem',
      }
  }
})

export const CustomTableContainer = styled(TableContainer)(({theme}) => {
  return {
    height: 'calc(100vh - 290px)', // Mobile (< md) (3 lines)
    borderRadius: "8px",
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100vh - 260px)' // Tablet (md to < lg) (2 lines)
    },
    [theme.breakpoints.up('md')]: {
      height: 'calc(100vh - 250px)' // Tablet (md to < lg) (2 lines)
    },
    [theme.breakpoints.up('lg')]: {
      height: 'calc(100vh - 210px)' // Desktop (lg+) (1 line)
    }
  }
});